import React, { useState } from 'react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/bn_BD';
import 'antd/dist/antd.css';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import { createFinalResultApi } from '../../../../api/master.api';
import { uploadGeneralCaseFileApi } from '../../../../api/uploadFile.api';
import swal from 'sweetalert';
const FinalResult = () => {
    const { entry_id } = useParams();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        has_judgment: false,
        judgment_date: '',
        summary_text: '',
        copy_applied_date: '',
        copy_received_date: '',
        caseType: '',
        documents: [{ name: '', file: null }]
    });


    const [showModal, setShowModal] = useState(false);
    const [showDetailedForm, setShowDetailedForm] = useState(false);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };
    const handleDateChange = (field, date) => {
        if (date && moment.isMoment(date) && date.isValid()) {
            handleInputChange(field, date.format('YYYY-MM-DD'));
        } else if (date === null) {
            handleInputChange(field, '');
        } else {
            console.warn('Invalid date selected:', date);
            handleInputChange(field, '');
        }
    };

    const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };


    const handleCheckboxChange = (checked) => {
        setFormData(prev => ({
            ...prev,
            has_judgment: checked
        }));

        if (checked) {
            setShowModal(true);
        } else {
            setShowDetailedForm(false);
        }
    };

    const handleModalConfirm = (answer) => {
        setShowModal(false);
        if (answer === 'yes') {
            setShowDetailedForm(true);
        } else {
            setShowDetailedForm(false);
            setFormData(prev => ({
                ...prev,
                has_judgment: false
            }));
        }
    };

    const addDocument = () => {
        setFormData(prev => ({
            ...prev,
            documents: [...prev.documents, { name: '', file: null }]
        }));
    };

    const removeDocument = (index) => {
        if (formData.documents.length > 1) {
            setFormData(prev => ({
                ...prev,
                documents: prev.documents.filter((_, i) => i !== index)
            }));
        }
    };

    const updateDocument = (index, field, value) => {
        const updatedDocs = [...formData.documents];
        updatedDocs[index] = { ...updatedDocs[index], [field]: value };
        setFormData(prev => ({
            ...prev,
            documents: updatedDocs
        }));
    };


    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        try {
            const uploadedDocs = await Promise.all(
                formData.documents.map(async (doc) => {
                    if (doc.file) {
                        const res = await uploadGeneralCaseFileApi(doc.file);
                        console.log(res,"res")
                        const fileUrl = res.data?.data?.filePath;
                        console.log(fileUrl, "fileUrl")
                        return { ...doc, url: fileUrl, file: null };
                    }
                    return doc;
                })
            );

            const documents = uploadedDocs
                .map((d) => ({ name: d.name, url: d.url }))
                .filter((d) => d.name && d.url);

            const finalData = {
                case_entry_id: Number(entry_id),
                judgment_date: formData.judgment_date,
                summary_text: formData.summary_text,
                copy_applied_date: formData.copy_applied_date,
                copy_received_date: formData.copy_received_date,
                caseType: formData.caseType,
                documents,
                created_by: user?.id,
            };

            const res = await createFinalResultApi(finalData);

            if (res.data?.success) {
                swal({ title: 'Thank you', text: 'Successfully Added', icon: 'success', button: 'Ok' });
                setFormData({
                    has_judgment: false,
                    judgment_date: '',
                    summary_text: '',
                    copy_applied_date: '',
                    copy_received_date: '',
                    caseType: '',
                    documents: [{ name: '', file: null }]

                });
                navigate(-1);
            }
        } catch (err) {
            console.error('Submit failed:', err);
            alert('Something went wrong while submitting.');
        }
    };




    const styles = {
        formInput: {
            width: '100%',
            padding: '10px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            backgroundColor: 'white'
        },
        textarea: {
            width: '100%',
            padding: '10px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'vertical',
            backgroundColor: 'white',
            minHeight: '120px'
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '8px',
            color: '#374151'
        },
        datePicker: {
            width: '100%',
            height: '36px'
        },
        checkboxOption: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            padding: '12px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            backgroundColor: 'white',
            marginBottom: '20px'
        },
        uploadSection: {
            backgroundColor: '#a7f3d0',
            border: '1px solid #6ee7b7',
            padding: '16px',
            marginBottom: '20px',
            borderRadius: '4px'
        },
        uploadHeader: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#065f46',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        uploadHeaderText: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        },
        addButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#059669',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        removeButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        browseButton: {
            padding: '8px 16px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        submitButton: {
            padding: '12px 32px',
            backgroundColor: 'rgb(104, 48, 145)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            fontSize: '16px'
        },
        documentRow: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '12px',
            backgroundColor: 'white',
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #d1d5db'
        },
        fileLabel: {
            fontSize: '14px',
            color: '#4b5563',
            minWidth: '120px'
        },
        modal: {
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        },
        modalContent: {
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            maxWidth: '400px',
            width: '90%'
        },
        modalIcon: {
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#fed7aa',
            border: '3px solid #fb923c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            fontSize: '24px',
            color: '#ea580c'
        },
        modalTitle: {
            fontSize: '18px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#374151'
        },
        modalText: {
            fontSize: '14px',
            color: '#6b7280',
            marginBottom: '24px',
            lineHeight: '1.5'
        },
        modalButtons: {
            display: 'flex',
            gap: '12px',
            justifyContent: 'center'
        },
        modalButtonYes: {
            padding: '10px 20px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        modalButtonNo: {
            padding: '10px 20px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        radioGroup: {
            display: 'flex',
            gap: '24px',
            marginTop: '8px'
        },
        radioOption: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px'
        }
    };
    return (
        <div className='page-wrapper'>
            <div style={{ backgroundColor: '#f8f9fa', textAlign: 'left', minHeight: '100vh' }}>
                <div style={{ maxWidth: '1000px', margin: '0 auto', backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>

                    {/* Initial Checkbox */}
                    <div style={styles.checkboxOption}>
                        <input
                            type="checkbox"
                            checked={formData.has_judgment}
                            onChange={(e) => handleCheckboxChange(e.target.checked)}
                            style={{ marginRight: '12px' }}
                        />
                        <span>মামলার রায়/চুড়ান্ত আদেশ হয়ে থাকলে সিলেক্ট করুন</span>
                    </div>

                    {/* Detailed Form - Shows when checkbox is checked and confirmed */}
                    {showDetailedForm && (
                        <>
                            {/* Date and Type Section */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <label style={styles.label}>
                                        রায় ঘোষণার তারিখ
                                    </label>

                                    <DatePicker
                                        style={styles.datePicker}
                                        placeholder="দিন/মাস/বছর"
                                        value={getSafeDateValue(formData.judgment_date)}
                                        onChange={(date) => handleDateChange('judgment_date', date)}
                                        format="DD/MM/YYYY"
                                        locale={locale}
                                        allowClear={true}
                                        inputReadOnly={false}
                                        showToday={true}
                                        showTime={false}
                                        status={formData.judgment_date && !getSafeDateValue(formData.judgment_date) ? 'error' : ''}
                                        onBlur={(e) => {
                                            const inputValue = e.target.value;
                                            if (inputValue) {
                                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                                if (parsedDate.isValid()) {
                                                    handleDateChange('judgment_date', parsedDate);
                                                }
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label style={styles.label}>
                                        ফলাফল
                                    </label>
                                    <div style={styles.radioGroup}>
                                        <label style={styles.radioOption}>
                                            <input
                                                type="checkbox"
                                                name="caseType"
                                                value="GOVT_FOR"
                                                checked={formData.caseType === 'GOVT_FOR'}
                                                onChange={(e) => handleInputChange('caseType', e.target.value)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            সরকারের পক্ষে
                                        </label>
                                        <label style={styles.radioOption}>
                                            <input
                                                type="checkbox"
                                                name="caseType"
                                                value="GOVT_AGAINST"
                                                checked={formData.caseType === 'GOVT_AGAINST'}
                                                onChange={(e) => handleInputChange('caseType', e.target.value)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            সরকারের বিপক্ষে
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Case Details */}
                            <div style={{ marginBottom: '24px' }}>
                                <label style={styles.label}>
                                    মামলার রায়ের সংক্ষিপ্ত বিবরণ
                                </label>
                                <textarea
                                    style={styles.textarea}
                                    value={formData.summary_text}
                                    onChange={(e) => handleInputChange('summary_text', e.target.value)}
                                />
                            </div>

                            {/* New Case Information */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <label style={styles.label}>
                                        রায়ের নকল প্রাপ্তির জন্য আবেদনের তারিখ
                                    </label>


                                    <DatePicker
                                        style={styles.datePicker}
                                        placeholder="দিন/মাস/বছর"
                                        value={getSafeDateValue(formData.copy_applied_date)}
                                        onChange={(date) => handleDateChange('copy_applied_date', date)}
                                        format="DD/MM/YYYY"
                                        locale={locale}
                                        allowClear={true}
                                        inputReadOnly={false}
                                        showToday={true}
                                        showTime={false}
                                        status={formData.copy_applied_date && !getSafeDateValue(formData.copy_applied_date) ? 'error' : ''}
                                        onBlur={(e) => {
                                            const inputValue = e.target.value;
                                            if (inputValue) {
                                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                                if (parsedDate.isValid()) {
                                                    handleDateChange('copy_applied_date', parsedDate);
                                                }
                                            }
                                        }}
                                    />

                                </div>
                                <div className="col-md-6">
                                    <label style={styles.label}>
                                        রায়ের নকল প্রাপ্তির তারিখ
                                    </label>

                                    <DatePicker
                                        style={styles.datePicker}
                                        placeholder="দিন/মাস/বছর"
                                        value={getSafeDateValue(formData.copy_received_date)}
                                        onChange={(date) => handleDateChange('copy_received_date', date)}
                                        format="DD/MM/YYYY"
                                        locale={locale}
                                        allowClear={true}
                                        inputReadOnly={false}
                                        showToday={true}
                                        showTime={false}
                                        status={formData.copy_received_date && !getSafeDateValue(formData.copy_received_date) ? 'error' : ''}
                                        onBlur={(e) => {
                                            const inputValue = e.target.value;
                                            if (inputValue) {
                                                const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                                if (parsedDate.isValid()) {
                                                    handleDateChange('copy_received_date', parsedDate);
                                                }
                                            }
                                        }}
                                    />

                                </div>
                            </div>

                            {/* Document Upload Section */}
                            <div style={styles.uploadSection}>
                                <div style={styles.uploadHeader}>
                                    <div style={styles.uploadHeaderText}>
                                        <span>সংযুক্ত (চূড়ান্ত আদেশ/রায় সম্পর্কিত কপি সংযুক্ত করুন)</span>
                                        <span style={{ fontSize: '12px', color: '#dc2626', fontWeight: 'normal' }}>
                                            (PDF, সর্বোচ্চ সাইজ : 5MB)
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={addDocument}
                                        style={styles.addButton}
                                        onMouseOver={(e) => e.target.style.backgroundColor = '#047857'}
                                        onMouseOut={(e) => e.target.style.backgroundColor = '#059669'}
                                    >
                                        <i className="fas fa-plus" style={{ fontSize: '14px' }}></i>
                                    </button>
                                </div>

                                {formData.documents.map((doc, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>

                                        {/* Document Name */}
                                        <input
                                            type="text"
                                            // placeholder="ডকুমেন্টের নাম"
                                            value={doc.name}
                                            onChange={(e) => {
                                                const updatedDocs = [...formData.documents];
                                                updatedDocs[index].name = e.target.value;
                                                setFormData({ ...formData, documents: updatedDocs });
                                            }}
                                            style={{ ...styles.formInput, flex: '1', width: "30%" }}
                                        />

                                        {/* File Upload */}
                                        <input
                                            type="file"
                                            accept=".pdf,.doc,.docx"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                const updatedDocs = [...formData.documents];
                                                updatedDocs[index].file = file;
                                                setFormData({ ...formData, documents: updatedDocs });
                                            }}
                                            style={{ flex: '1', width: "40%", backgroundColor: '#f3f4f6', border: '1px solid #cbd5e1', borderRadius: '4px', padding: '8px' }}
                                        />

                                        {/* Remove Button */}
                                        <button
                                            type="button"
                                            onClick={() => removeDocument(index)}
                                            style={{
                                                width: '24px',
                                                height: '24px',
                                                backgroundColor: '#ef4444',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                        >
                                            <i className="fas fa-minus" style={{ fontSize: '12px' }}></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    {/* Submit Button */}
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                        <button
                            type="submit"
                            onClick={handleSubmit}
                            style={styles.submitButton}
                            onMouseOver={(e) => e.target.style.backgroundColor = 'rgb(104, 48, 145)'}
                            onMouseOut={(e) => e.target.style.backgroundColor = 'rgb(104, 48, 145)'}
                        >
                            সংরক্ষণ
                        </button>
                    </div>
                </div>

                {/* Confirmation Modal */}
                {showModal && (
                    <div style={styles.modal} onClick={() => setShowModal(false)}>
                        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                            <div style={styles.modalIcon}>
                                <i className="fas fa-exclamation" style={{ fontSize: '24px' }}></i>
                            </div>
                            <h3 style={styles.modalTitle}>
                                আপনি কি নিশ্চিত?
                            </h3>
                            <p style={styles.modalText}>
                                আপনি কি মামলার রায়ের অবস্থা পরিবর্তন করতে চান?
                            </p>
                            <div style={styles.modalButtons}>
                                <button
                                    onClick={() => handleModalConfirm('yes')}
                                    style={styles.modalButtonYes}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                                >
                                    হ্যাঁ
                                </button>
                                <button
                                    onClick={() => handleModalConfirm('no')}
                                    style={styles.modalButtonNo}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                                >
                                    না
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FinalResult;